export const getFileName = (filename: string) => filename.replace(/^.*[\\/]/, '');

export default getFileName;
